import { track } from "./trackEvent";

export const trackPinningSessionChatOpened = (options: {
  sessionId: string;
  artworkId: string;
  pinsCount: number;
  lastPinState: string | null;
}) => {
  track("pinning_session_chat_opened", {
    session_id: options.sessionId,
    artwork_id: options.artworkId,
    pins_count: options.pinsCount,
    last_pin_state: options.lastPinState,
    timestamp: Date.now()
  });
};

export const trackPinningSessionEntryInput = (options: {
  artworkId: string;
  placement: string;
  inputValue: string;
}) => {
  track("pinning_session_entry_input", {
    artwork_id: options.artworkId,
    placement: options.placement,
    input: options.inputValue,
    timestamp: Date.now()
  });
};

export const trackPinSessionsGenPreviewBeforeClicked = (options: {
  sessionId: string;
  artworkId: string;
  generatedImageUrl: string;
}) => {
  track("pin_sessions_gen_preview_before_clicked", {
    session_id: options.sessionId,
    artwork_id: options.artworkId,
    generated_image_url: options.generatedImageUrl,
    timestamp: Date.now()
  });
};

export const trackPinSessionsGenConfirmed = (options: {
  artworkId: string;
  sessionId: string;
  pinId: string;
}) => {
  track("pin_sessions_gen_confirmed", {
    artwork_id: options.artworkId,
    session_id: options.sessionId,
    pin_id: options.pinId,
    timestamp: Date.now()
  });
};

export const trackPinSessionsGenPreviewAfterClicked = (options: {
  sessionId: string;
  artworkId: string;
  generatedImageUrl: string;
}) => {
  track("pin_sessions_gen_preview_after_clicked", {
    session_id: options.sessionId,
    artwork_id: options.artworkId,
    generated_image_url: options.generatedImageUrl,
    timestamp: Date.now()
  });
};

export const trackPinSessionsGenDiscarded = (options: {
  artworkId: string;
  sessionId: string;
  pinId: string;
}) => {
  track("pin_sessions_gen_discarded", {
    artwork_id: options.artworkId,
    session_id: options.sessionId,
    pin_id: options.pinId,
    timestamp: Date.now()
  });
};

export const trackPinSessionGeneratedImageShown = (options: {
  sessionId: string;
  artworkId: string;
  generatedImageUrl: string;
  pinId: string;
}) => {
  track("pin_session_generated_image_shown", {
    session_id: options.sessionId,
    artwork_id: options.artworkId,
    generated_image_url: options.generatedImageUrl,
    pin_id: options.pinId,
    timestamp: Date.now()
  });
};
